import './App.css';
import React, { useEffect, useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';

import SignIn from './components/auth/SignnIn';
import Navbar from './components/Header';
import Home from './components/home/Home';

function App() {

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 600);

  useEffect(() => {
    const handleResize = () => {
        setIsSmallScreen(window.innerWidth < 600);
    };

    window.addEventListener('resize', handleResize);

    return () => {
        window.removeEventListener('resize', handleResize);
    };
}, []);
  
  return (
    <Router>
      <Navbar isSmallScreen={isSmallScreen}/>
      <Routes>
        <Route exact path='/' element={<Home />}></Route>
        <Route exact path='/auth/signin' element={<SignIn />}></Route>    
      </Routes>
     
    </Router>
  );
}

export default App;
